import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#D3EFEC",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "m9 1.69-3 3v9.62l3-3zM2.78 2.97a.75.75 0 0 0-1.28.53V11c0 .199.079.39.22.53l2.78 2.78V4.69zM13.28 4.47 10.5 1.69v9.62l1.72 1.72a.75.75 0 0 0 1.28-.53V5a.75.75 0 0 0-.22-.53" })
    ], -1)
  ]))]))
}
export default { render: render }